import { PROJECT_PATH, WORKFLOW_PATH } from '../url';
import ErrorSwitchCase from './ErrorHandlerService';
import HttpService from './HttpService';
const _axios = HttpService.getAxiosClient();

export const applyLeave = async (leavePayload, officeLocationId) => {
  try {
    const response = await _axios.post(
      `${WORKFLOW_PATH}/leaves/application/saveProcess?${officeLocationId ? 'officeLocationId=' + officeLocationId : ''}`,
      leavePayload,
    );
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response.data);
  }
};

const leaveTypeListCache = new Map();

export const getLeaveTypeList = async (year) => {
  const cacheKey = year ?? '';
  if (leaveTypeListCache.has(cacheKey)) {
    return leaveTypeListCache.get(cacheKey);
  }
  const requestPromise = (async () => {
    try {
      const response = await _axios.get(
        `${PROJECT_PATH}/leave-type?${year ? 'year=' + year : ''}`,
      );
      return ErrorSwitchCase(response);
    } catch (error) {
      return ErrorSwitchCase(error.response.data);
    }
  })();
  leaveTypeListCache.set(cacheKey, requestPromise);
  const result = await requestPromise;
  if (result.isError !== false) {
    leaveTypeListCache.delete(cacheKey);
  }
  return result;
};
